module.exports = require('./helpers/bundle-url').getBundleURL('e6gRn') + "logo-dark.eefe0b7f.svg";